import { NEUTRAL, resolveTheme } from '../../designTokens';

// T-12: mörkt sidhuvud med accentglöd (samma som Hem, Kunder, Klientkort).
// title/subtitle till vänster, `actions` till höger, valfritt `search` (text, onChange,
// placeholder) som fält under rubriken och `children` under det (t.ex. chips).
export default function DarkHeader({ theme, label, title, subtitle, actions, search, children, padding = '22px 24px', className }) {
  const t = theme || resolveTheme();
  return (
    <div className={`fr-darkhead${className ? ' ' + className : ''}`} style={{ position: 'relative', overflow: 'hidden', background: NEUTRAL.ink, borderRadius: t.card_radius, padding, color: '#FFFFFF', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div aria-hidden="true" style={{ position: 'absolute', top: '-150px', right: '-70px', width: '360px', height: '360px', borderRadius: '999px', background: t.hero_glow, opacity: 0.30, filter: 'blur(40px)', pointerEvents: 'none' }} />
      <div className="fr-darkhead-inner" style={{ position: 'relative', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '12px' }}>
        <div style={{ minWidth: 0 }}>
          {label && <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.10em', textTransform: 'uppercase', color: t.accent_soft_bg, marginBottom: '4px' }}>{label}</div>}
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '800', letterSpacing: '-0.01em', lineHeight: 1.1, color: '#FFFFFF', fontFamily: 'var(--font-heading)' }}>{title}</h1>
          {subtitle && <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.72)', marginTop: '4px' }}>{subtitle}</div>}
        </div>
        {actions && <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>{actions}</div>}
      </div>
      {search && (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.16)', borderRadius: '10px', padding: '0 14px' }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="4.5" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" /><path d="M10.5 10.5L14 14" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" /></svg>
          <input
            type="search"
            aria-label={search.placeholder || 'Sök'}
            placeholder={search.placeholder || 'Sök…'}
            value={search.value}
            onChange={e => search.onChange(e.target.value)}
            style={{ flex: 1, background: 'transparent', border: 'none', color: '#FFFFFF', padding: '11px 0', fontSize: '14px', outline: 'none', fontFamily: 'inherit', minWidth: 0 }}
          />
        </div>
      )}
      {children && <div style={{ position: 'relative' }}>{children}</div>}
    </div>
  );
}

// Knappstilar för mörka huvuden
export function darkPrimary(theme) {
  const t = theme || resolveTheme();
  return { background: t.hero_btn_bg, border: `1px solid ${t.hero_btn_bg}`, color: t.hero_btn_text, padding: '9px 14px', borderRadius: t.btn_radius, fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' };
}
export function darkGhost(theme) {
  const t = theme || resolveTheme();
  return { background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.22)', color: '#FFFFFF', padding: '9px 14px', borderRadius: t.btn_radius, fontSize: '13px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' };
}
